var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OverlayArrow } from "react-aria-components";
import { StyledPopover } from "./styled";
const IngredientPopover = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsxs(StyledPopover, Object.assign({}, props, { children: [_jsx(OverlayArrow, { children: _jsx("svg", { height: 12, viewBox: "0 0 12 12", width: 12, children: _jsx("path", { d: "M0 0 L6 6 L12 0" }) }) }), children] })));
};
export default IngredientPopover;
